<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'SignificantAssetsYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Have you bought, sold, or inherited any high-value items or assets since your Will was made?',
        subTitle: 'Your Will outlines the distribution of your wealth, so major changes to what you own directly impact your estate planning. This includes things like expensive artwork, vehicles, jewelry, or large inheritances you have received. If you have promised a specific item to someone in your Will but no longer own it, or if you have acquired new valuables that are not mentioned, your Will requires an update.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'significantAssetsYN',
        formPath: 'significantAssetsYN',
        jsonSaveField: 'significantAssetsYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
